const debug       = false;
myApp.nativeUI    = {};
myApp.windows     = []; // Array to hold references to our generic custom windows, which are created via our helper method
myApp.mainWindow = {};

// Main Entry Point
myApp.nativeUI.init = function () {
    if(debug) console.log('Initialize NativeUI');

    // Instance our NW GUI
    myApp.nw            = nw;

    // Globals
    nw.global.openWindow        = myApp.nativeUI.openWindow;
    nw.global.resizeWindow      = myApp.nativeUI.resizeWindow;
    nw.global.configureWindow   = myApp.nativeUI.configureWindow;
    myApp.bgWindow              = myApp.nw.Window.get();
    myApp.name                  = myApp.nw.App.manifest.name;

    // register Events for our BG Window
    myApp.bgWindow.on('close', function () {
        if(debug) console.log('Close BG Win');
        myApp.nw.App.closeAllWindows();
        myApp.bgWindow.close(true);
        myApp.bgWindow = null;

        myApp.nw.App.quit();
    });


    // Open up the actual application view in a new window,
    // this makes live reloading and script persistent with the different contexts a bit easier to handle
    myApp.mainWindow    = myApp.nw.Window.open('resources/views/index.html', {} , function(win) {
        myApp.mainWindow = win;
        if(debug) console.log('Main Window Loaded', myApp.mainWindow);

        // Load our Window Config
        if(nw.App.manifest.window.resizable)
            myApp.mainWindow.setResizable( nw.App.manifest.window.resizable );

        if(nw.App.manifest.window.alwaysOnTop)
            myApp.mainWindow.isAlwaysOnTop = nw.App.manifest.window.alwaysOnTop;
        if(nw.App.manifest.window.fullscreen)
            myApp.mainWindow.isFullscreen = nw.App.manifest.window.fullscreen;
        if(nw.App.manifest.window.transparent)
            myApp.mainWindow.isTransparent = nw.App.manifest.window.transparent;

        myApp.nativeUI.resizeWindow();
        myApp.nativeUI.configureWindow();

        if(nw.global.preferences.rememberWindowPosition)
            myApp.nativeUI.restoreWindowPosition();

        // Register Events for our main window
        win.on('closed', function () {
            win                 = null;
            myApp.mainWindow    = null;
        });
        win.on('close', function () {
            if(debug) console.log('App is being Closed!');

            if( localStorage ) {
                localStorage.windowX       = myApp.mainWindow.x;
                localStorage.windowY       = myApp.mainWindow.y;
                localStorage.windowWidth   = myApp.mainWindow.width;
                localStorage.windowHeight  = myApp.mainWindow.height ;
            }

            myApp.nw.App.closeAllWindows();
            this.close(true);
        });
        win.on('minimize', function() {
            // Hide window to the tray (TODO config option for this?)
            this.hide();
        });

        //
        // Load our additional UI components
        require('./options');
        require('./about');
        require('./tray');

        // Construct our Tray Menu after the creation of the main Window (its needed as reference) (TODO config option for this?)
        myApp.nativeUI.tray.init();


        // Apply Additional App Wide Events, which require the main Window as reference
        myApp.nw.App.on('reopen', function () {
            myApp.mainWindow.focus();
        });

        // Finally set the focus onto our apps main Window
        myApp.mainWindow.focus();
    });
};


myApp.nativeUI.openWindow = function ( file, options) {
    if(debug) console.log('Open Window', file);

    // Make sure our window does not exist yet (to avoid, that we open it up twice)
    if(myApp.windows[file])
        return false;

    // Create a new Window element for our about menu
    myApp.windows[file] = myApp.nw.Window.open( file, options , function(win) {
        myApp.windows[file] = win;

        //
        // Register Element events

        // Focus hack, to ensure the about window remains always focused
        myApp.mainWindow.on('focus', function() {
            myApp.windows[file].focus();
        });

        // Clear up all linked data from our Object
        myApp.windows[file].on('closed', function() {
            myApp.windows[file].removeAllListeners('focus');
            myApp.windows[file]     = null;
        });
    });
};
myApp.nativeUI.resizeWindow = function () {
    if (debug) console.log('Resize Window');
    if (nw.App.manifest.window.width && nw.App.manifest.window.height) {
        myApp.mainWindow.resizeTo(nw.App.manifest.window.width, nw.App.manifest.window.height);

        const xPos = window.screen.availWidth / 2 - nw.App.manifest.window.width / 2;
        const yPos = window.screen.availHeight / 2 - nw.App.manifest.window.height / 2;
        myApp.mainWindow.x = xPos;
        myApp.mainWindow.y = yPos;

        localStorage.windowWidth   = nw.App.manifest.window.width;
        localStorage.windowHeight  = nw.App.manifest.window.height;
        localStorage.windowX       = xPos;
        localStorage.windowY       = yPos;
    } else if (debug) console.log('Cannot Resize Window Position, reference dimension is missing!');
};
myApp.nativeUI.configureWindow = function () {
    if (debug) console.log('Configure Window');

    if(nw.App.manifest.window.kiosk || nw.App.manifest.config.kiosk)
        myApp.mainWindow.isKioskMode = nw.global.preferences.kiosk;
};
//
// Helper Functions
myApp.nativeUI.remove = function () {
    if(debug) console.log('Remove NativeUI');
    myApp.nativeUI.removeTray();
};
myApp.nativeUI.listenForStorageEvents = function () {
    if(debug) console.log('Setup Local Storage Listener!');

    window.addEventListener('storage', function() {
        if(debug) console.log('Locale Storage Update');
    });
};
myApp.nativeUI.restoreWindowPosition = function () {
    if(debug) console.log('Restoring old Window Position');

    if( localStorage.windowX !== undefined) {
        myApp.mainWindow.x      = parseInt(localStorage.windowX);
        myApp.mainWindow.y      = parseInt(localStorage.windowY);
        // TODO Only if window is resizable?
        myApp.mainWindow.width  = parseInt(localStorage.windowWidth);
        myApp.mainWindow.height = parseInt(localStorage.windowHeight);
    }
};